/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Tournaments_HeadingInputs */



/**
* | output |
* | --- |
* | "Tournaments" |
*
* @param {League_Tournaments_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_tournaments_heading = /** @type {((inputs?: League_Tournaments_HeadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Tournaments_HeadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tornei")
	return /** @type {LocalizedString} */ ("Tournaments")
});